<template>
  <div id="app">

    <Preloader ref="preloader" v-if="!canAnimate" />

    <MousePointer
      v-if="canCustomMouse"/>

    <!-- Header -->
    <header
      class="header">

      <FrameElement
        v-if="canAnimate">
         <p class="header__title">
            <a href="/">Davide Marchet</a>
        </p>
      </FrameElement>

      <FrameElement
        v-if="canAnimate">
        <p>Web Developer</p>
      </FrameElement>

    </header>
    <!-- Header -->

    <smooth-scrollbar
      v-if="canVirtualScroll">
      <div id="scroller" class="scroller">
        <router-view
          :canAnimate="canAnimate"
          @isLoad="isLoad = true"/>
      </div>
    </smooth-scrollbar>

    <router-view
      v-else
      :canAnimate="canAnimate"
      @isLoad="isLoad = true"/>

    <!-- Footer -->
    <footer class="footer text-xsmall">

      <FrameElement
        v-if="canAnimate">
        <p>
          <a href="https://github.com/DidoMarchet" target="_blank" rel="noreferrer">Github</a>
          <a href="https://twitter.com/didomarket" target="_blank" rel="noreferrer">Twitter</a>
          <a href="/assets/pdf/davide-marchet-web-desginer-developer.pdf" target="_blank" rel="noreferrer">Cv</a>
        </p>
      </FrameElement>

      <FrameElement
        v-if="canAnimate">
        <p class="footer__contact">
          <a href="mailto:info@davidemarchet.com"><span>&#x2764;&#xFE0F;</span> Get in touch</a>
        </p>
      </FrameElement>

    </footer>
    <!-- Footer -->

  </div>
</template>

<script>
import MousePointer from '@/components/MousePointer/MousePointer.vue'
import Preloader from '@/components/Preloader/Preloader.vue'
import FrameElement from '@/components/FrameElement/FrameElement.vue'
import anime from 'animejs'

export default {
  name: 'App',
  components: {
    MousePointer,
    FrameElement,
    Preloader
  },
  data: () => ({
    canVirtualScroll: undefined,
    canCustomMouse: false,
    isLoad: false,
    canAnimate: false
  }),
  mounted () {
    if (matchMedia('(pointer:fine)').matches) {
      this.canCustomMouse = true
    }
    if (!matchMedia('(pointer:fine)').matches || navigator.appVersion.indexOf('Edge') !== -1) {
      this.canVirtualScroll = false
    } else {
      this.canVirtualScroll = true
      document.body.classList.add('virtual-scroll')
    }
  },
  watch: {
    isLoad: {
      handler (val) {
        anime({
          targets: this.$refs.preloader.$el,
          opacity: [1, 0],
          easing: 'linear',
          duration: 1500,
          delay: 1500,
          complete: () => {
            this.canAnimate = true
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">

@import './main.scss';

</style>
